import {createLoadingSelector, getMappingProviders, getWorkforceProviders} from "../../../selectors";
import React, {Component, Fragment} from "react";
import {connect} from 'react-redux';
import { toastr } from 'react-redux-toastr';
import Loader from "../../../components/Loader";
import BootstrapTable from 'react-bootstrap-table-next';
import {
    MAPPING_SYSTEM_FIND_PROVIDER_BY_ID, MAPPING_SYSTEM_ALL_PROVIDERS_IDS, MAPPING_SYSTEM_CURRENT_ID,
    WORKFORCE_FIND_PROVIDER_BY_ID , WORKFORCE_FIND_CURRENT_PROVIDER_ID, WORKFORCE_ALL_PROVIDERS_IDS,
    getMappingSystemProviderById, getMappingSystemCurrentId, getMappingSystemAllProviders, getMappingSystemAllProviderIDS,
    getWorkforceProviderByID, getWorkforceCurrentProviderID, getWorkforceAllProviders, getWorkforceAllProvidersIDS,
    setMappingSystemProvider, setCurrentWorkforce, clearCurrentWorkforceProviderId, clearWorkforceAllIds, clearWorkforceProviderIds,
    clearMappingProviderId, clearMappingAllIds, clearMappingProviderIds, patchMappingSystem, patchWorkforce,
} from "../../../actions/workforce.actions";
import {Formik} from "formik";
import FormSelect from "../../../components/UI/FormSelect";
import TextInput from "../../../components/UI/TextInput";
import {getErrorMessage} from "../../../utils/helpers";
import {showModal} from "../../../actions/modal.actions";
import ToolkitProvider from "react-bootstrap-table2-toolkit";

class WorkforceConfiguration extends Component {

    componentDidMount() {
        document.title = 'Mapping Configuration - camvio.cloud';
        this.props.changeNavBarType('default', 'Mapping Configuration');

        this.props.getMappingSystemCurrentId().then(resp => {
            this.props.getMappingSystemProviderById(resp.data.id);
        });

        this.props.getWorkforceCurrentProviderID().then(resp => {
            this.props.getWorkforceProviderByID(resp.data.id);
        });

        this.props.getMappingSystemAllProviderIDS();
        this.props.getWorkforceAllProvidersIDS();
    }

    componentWillUnmount() {
        this.props.clearCurrentWorkforceProviderId();
        this.props.clearWorkforceAllIds();
        this.props.clearWorkforceProviderIds();

        this.props.clearMappingProviderId();
        this.props.clearMappingAllIds();
        this.props.clearMappingProviderIds();
    }

    handleSubmit = (values, actions) => {
        actions.setSubmitting(false);
    }

    onCurrentMappingSystemProviderChangeHandler = (name, value, formProps) => {
        formProps.setFieldValue(name, value);
        if (value) {
            this.props.getMappingSystemProviderById(value).then(resp => {
                formProps.setFieldValue('mappingSystemConfiguration', resp.data);
            });
        } else {
            formProps.setFieldValue('mappingSystemConfiguration', null);
        }
    }

    onCurrentWorkforceProviderChangeHandler = (name, value, formProps) => {
        formProps.setFieldValue(name, value);
        if (value) {
            this.props.getWorkforceProviderByID(value).then(resp => {
                formProps.setFieldValue('workforceConfiguration', resp && resp.data);
            });
        } else {
            formProps.setFieldValue('workforceConfiguration', null);
        }
    }

    setCurrentMappingSystemProvider = ({setSubmitting, values}) => {
        setSubmitting(true);

        this.props.setMappingSystemProvider(values.mappingProviderId)
            .then((response) => {
                if (response.success === false) {
                    console.error(response);
                    toastr.error(getErrorMessage(response).message, { position: 'top-center' });
                } else {
                    const message = response.data && response.data.message || response.data || 'New mapping system successfully set as current';
                    toastr.success(message, { timeOut: 3000, position: 'top-center' });
                }

                setSubmitting(false);
            }).catch(e => {
            console.error(e);
            toastr.error("Something went wrong", { timeOut: 5000, position: 'top-center' });

            setSubmitting(false);
        });
    }

    setCurrentWorkforceProvider = ({setSubmitting, values}) => {
        setSubmitting(true);

        this.props.setCurrentWorkforce(values.workforceProviderId)
            .then((response) => {
                if (response.success === false) {
                    console.error(response);
                    toastr.error(getErrorMessage(response).message, { position: 'top-center' });
                } else {
                    const message = response.data && response.data.message || response.data || 'New workforce provider successfully set as current';
                    toastr.success(message, { timeOut: 3000, position: 'top-center' });
                }

                setSubmitting(false);
            }).catch(e => {
            console.error(e);
            toastr.error("Something went wrong", { timeOut: 5000, position: 'top-center' });

            setSubmitting(false);
        });
    }

    onSetCurrentProviderBtnClick = (formProps) => {
        const selectedProviderId = formProps.values.mappingProviderId;
        const mappingProviderId = selectedProviderId && selectedProviderId !== 'null' && selectedProviderId || 'NONE';

        toastr.confirm("Are you sure you want to set the current provider to " + mappingProviderId, {
            cancelText: "Cancel",
            okText: "Confirm",
            onOk: () => this.setCurrentMappingSystemProvider(formProps)
        })
    }

    onSetCurrentWorkforceProviderBtnClick = (formProps) => {
        const workforceSelectedProviderId = formProps.values.workforceProviderId;
        const workforceProviderId = workforceSelectedProviderId && workforceSelectedProviderId !== 'null' && workforceSelectedProviderId || 'NONE';

        toastr.confirm("Are you sure you want to set the current provider to " + workforceProviderId, {
            cancelText: "Cancel",
            okText: "Confirm",
            onOk: () => this.setCurrentWorkforceProvider(formProps)
        })
    }

    saveMappingSystemConfiguration = ({setSubmitting, values}) => {
        setSubmitting(true);

        this.props.patchMappingSystem(values.mappingProviderId, values.mappingSystemConfiguration)
            .then((response) => {
                if (response.success === false) {
                    console.error(response);
                    toastr.error(getErrorMessage(response).message, { position: 'top-center' });
                } else {
                    const message = response.data && response.data.message || response.data || 'Mapping System updated successfully';

                    toastr.success(message, { timeOut: 3000, position: 'top-center' });

                    this.props.getMappingSystemProviderById(values.mappingProviderId)
                        .then(resp => setSubmitting(false))
                        .catch(error => {
                            console.error(error);
                            setSubmitting(false)
                        });
                }
            }).catch(e => {
            console.error(e);
            toastr.error("Something went wrong", { timeOut: 5000, position: 'top-center' });

            setSubmitting(false);
        });
    }

    saveWorkforceConfiguration = ({setSubmitting, values}) => {
        setSubmitting(true);

        this.props.patchWorkforce(values.workforceProviderId, values.workforceConfiguration)
            .then((response) => {
                if (response.success === false) {
                    console.error(response);
                    toastr.error(getErrorMessage(response).message, { position: 'top-center' });
                } else {
                    const message = response.data && response.data.message || response.data || 'Workforce updated successfully';

                    toastr.success(message, { timeOut: 3000, position: 'top-center' });

                    this.props.getWorkforceProviderByID(values.workforceProviderId)
                        .then(resp => setSubmitting(false))
                        .catch(error => {
                            console.error(error);
                            setSubmitting(false)
                        });
                }
            }).catch(e => {
            console.error(e);
            toastr.error("Something went wrong", { timeOut: 5000, position: 'top-center' });

            setSubmitting(false);
        });
    }

    oldValueFormatter = (cell, row) => {
        return (
            <div style={{maxWidth: '200px', wordBreak: 'break-all'}}>
                {row.oldVal}
            </div>
        );
    }

    newValueFormatter = (cell, row) => {
        return (
            <div style={{maxWidth: '200px', wordBreak: 'break-all'}}>
                {row.newVal}
            </div>
        );
    }

    onSaveButtonClick = (saveFunction, updatedProps, formProps) => {
        const columns = [{
            dataField: 'key',
            text: 'Name',
        }, {
            dataField: 'oldVal',
            text: 'Old Value',
            formatter: this.oldValueFormatter
        }, {
            dataField: 'newVal',
            text: 'New Value',
            formatter: this.newValueFormatter
        }];

        this.props.showModal('GENERIC_MODAL', {
            title: "Save Configuration",
            text: "Are you sure you want to make these changes?",
            size: 'lg',
            cancelText: "Cancel",
            okText: "Save",
            onOk: () => saveFunction(formProps),
            component: () => (
                <BootstrapTable
                    classes="table table-striped cmv-table"
                    keyField='key'
                    data={updatedProps}
                    columns={columns}
                />
            )
        });
    }


    render() {
        const {
            isLoadingCurrentProviderId, mappingCurrentProviderId, isLoadingProviderIds, currentWorkforceProviderId,
            isLoadingWorkforceConfiguration, mappingProviders, mappingProviderIds, isLoadingMappingSystemConfiguration,
            workforceProviders, workforceProviderIds, isLoadingCurrentWorkforceProviderId, isLoadingWorkforceProviderIds
        } = this.props;

        const mappingProviderIdOptions = [];

        if (mappingProviderIds) {
            mappingProviderIds.forEach(mid => mappingProviderIdOptions && mappingProviderIdOptions.push({label: mid, value: mid }));
        }

        const workforceProviderIdOptions = [];

        if (workforceProviderIds) {
            workforceProviderIds.forEach(wid => workforceProviderIdOptions.push({label: wid, value: wid }));
        }

        return (
            <div className="cmv-container cmv-container-dashboard cmv-container-client-selected">
                <Formik
                    initialValues={{
                        mappingProviderId: mappingCurrentProviderId,
                        mappingSystemConfiguration: mappingCurrentProviderId && mappingProviders && mappingProviders[mappingCurrentProviderId],
                        workforceProviderId: currentWorkforceProviderId,
                        workforceConfiguration: currentWorkforceProviderId && workforceProviders && workforceProviders[currentWorkforceProviderId],
                    }}
                    enableReinitialize={true}
                    onSubmit={this.handleSubmit}
                    render={(formProps) => {
                        const {handleChange, handleSubmit, handleBlur, values, errors, touched, isSubmitting, setFieldValue,} = formProps;

                        const originalMappingSystemConfiguration = mappingProviders && mappingProviders[values && values.mappingProviderId];
                        const mappingUpdatedProps = [];

                        originalMappingSystemConfiguration && values.mappingSystemConfiguration &&
                        originalMappingSystemConfiguration.properties.forEach(origProp => {
                            const currProp = values.mappingSystemConfiguration.properties.find(currProp => currProp.key === origProp.key);
                            if (currProp && currProp.value !== origProp.value) {
                                mappingUpdatedProps.push({ key: currProp.key, oldVal: origProp.value, newVal: currProp.value });
                            }
                        });

                        const originalWorkforceConfiguration = workforceProviders && workforceProviders[values.workforceProviderId];
                        const workforceUpdatedProps = [];

                        originalWorkforceConfiguration && values.workforceConfiguration &&
                        originalWorkforceConfiguration.properties.forEach(origProp => {
                            const workforceCurrProp = values.workforceConfiguration.properties.find(workforceCurrProp => workforceCurrProp.key === origProp.key);
                            if (workforceCurrProp && workforceCurrProp.value !== origProp.value) {
                                workforceUpdatedProps.push({ key: workforceCurrProp.key, oldVal: origProp.value, newVal: workforceCurrProp.value });
                            }
                        });



                        return (
                            <>
                                <form onSubmit={handleSubmit}>
                                    <div className="form-vertical">
                                        <div className="form-group">
                                            <FormSelect
                                                title="Current Mapping System"
                                                fieldName="mappingProviderId"
                                                placeholder="select a mapping system"
                                                options={mappingProviderIdOptions}
                                                setFieldValue={setFieldValue}
                                                value={values.mappingProviderId || null}
                                                onBlur={handleBlur}
                                                errors={errors}
                                                touched={touched}
                                                isDisabled={isLoadingCurrentProviderId || isLoadingProviderIds || isSubmitting}
                                                isLoading={isLoadingCurrentProviderId}
                                                onChange={(name, value) => this.onCurrentMappingSystemProviderChangeHandler(name, value, {values, setFieldValue})}
                                            />
                                        </div>
                                        <div style={{textAlign: 'right'}}>
                                            <button
                                                onClick={() => this.onSetCurrentProviderBtnClick(formProps)}
                                                disabled={isLoadingCurrentProviderId || isLoadingProviderIds || isSubmitting}
                                                type="button"
                                                className="btn btn-primary">
                                                {isSubmitting &&
                                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{marginRight: '5px'}}/>}
                                                Set As Current
                                            </button>
                                        </div>
                                        {(isLoadingCurrentProviderId || isLoadingProviderIds || isLoadingMappingSystemConfiguration) && <Loader />
                                            || values.mappingSystemConfiguration &&
                                            <div className='card-vertical card-plane'>
                                                <div className='card-body'>
                                                    <div className='plan-header plan-header-centered'>
                                                        <span className="plan-title"><i className="fas fa-fw fa-cogs"/> Configuration </span>
                                                    </div>
                                                    <div className='plan-body'>
                                                        <div className="form-group service-wrapper">
                                                            {values && values.mappingSystemConfiguration && values.mappingSystemConfiguration.properties.map((prop, idx) => {
                                                                const fieldName = `mappingSystemConfiguration.properties[${idx}].value`;

                                                                return (
                                                                    <TextInput
                                                                        label={prop.key}
                                                                        type="text"
                                                                        name={fieldName}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        value={prop.value || ''}
                                                                        disabled={isSubmitting}
                                                                        autocomplete={false}
                                                                    />
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                    <div style={{textAlign: 'right'}}>
                                                        <button
                                                            onClick={() => this.onSaveButtonClick(this.saveMappingSystemConfiguration, mappingUpdatedProps, formProps)}
                                                            disabled={isLoadingCurrentProviderId || isLoadingProviderIds || isSubmitting || mappingUpdatedProps.length < 1 }
                                                            type="button"
                                                            className="btn btn-primary">
                                                            {isSubmitting &&
                                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{marginRight: '5px'}}/>}
                                                            Save
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        <div className="form-group">
                                            <FormSelect
                                                title="Current Workforce Map"
                                                fieldName="workforceProviderId"
                                                placeholder="select a workforce provider"
                                                options={workforceProviderIdOptions}
                                                setFieldValue={setFieldValue}
                                                value={values.workforceProviderId || null }
                                                onBlur={handleBlur}
                                                errors={errors}
                                                touched={touched}
                                                isDisabled={isLoadingCurrentWorkforceProviderId || isLoadingWorkforceProviderIds || isSubmitting }
                                                isLoading={isLoadingCurrentWorkforceProviderId}
                                                onChange={(name, value) => this.onCurrentWorkforceProviderChangeHandler(name, value, {values, setFieldValue})}
                                            />
                                        </div>
                                        <div style={{textAlign: 'right'}}>
                                            <button
                                                onClick={() => this.onSetCurrentWorkforceProviderBtnClick(formProps)}
                                                disabled={isLoadingCurrentWorkforceProviderId || isLoadingWorkforceProviderIds || isSubmitting}
                                                type="button"
                                                className="btn btn-primary">
                                                {isSubmitting &&
                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{marginRight: '5px'}}/>}
                                                Set As Current
                                            </button>
                                        </div>
                                        {(isLoadingCurrentWorkforceProviderId || isLoadingWorkforceProviderIds || isLoadingWorkforceConfiguration) && <Loader />
                                            || values.workforceConfiguration &&
                                            <div className='card-vertical card-plane'>
                                                <div className='card-body'>
                                                    <div className='plan-header plan-header-centered'>
                                                        <span className="plan-title"><i className="fas fa-fw fa-cogs"/> Configuration</span>
                                                    </div>
                                                    <div className='plan-body'>
                                                        <div className="form-group service-wrapper">
                                                            {values && values.workforceConfiguration && values.workforceConfiguration.properties.map((prop, idx) => {
                                                                const fieldName = `workforceConfiguration.properties[${idx}].value`;

                                                                return (
                                                                    <TextInput
                                                                        label={prop.key}
                                                                        type="text"
                                                                        name={fieldName}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        value={prop.value || ''}
                                                                        disabled={isSubmitting}
                                                                        autocomplete={false}
                                                                    />
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                    <div style={{textAlign: 'right'}}>
                                                        <button
                                                            onClick={() => this.onSaveButtonClick(this.saveWorkforceConfiguration, workforceUpdatedProps, formProps)}
                                                            disabled={isLoadingWorkforceProviderIds || isLoadingWorkforceProviderIds || isSubmitting || workforceUpdatedProps.length < 1}
                                                            type="button"
                                                            className="btn btn-primary">
                                                            {isSubmitting &&
                                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{marginRight: '5px'}}/>}
                                                            Save
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </form>
                            </>
                        )}}/>
            </div>
        );
    }
}


const selectCurrentProviderIdLoading = createLoadingSelector(['MAPPING_SYSTEM_CURRENT_ID']);
const selectLoadingMappingSystemConfiguration = createLoadingSelector(['MAPPING_SYSTEM_FIND_PROVIDER_BY_ID']);
const selectLoadingProviderIds = createLoadingSelector(['MAPPING_SYSTEM_ALL_PROVIDERS_IDS']);
const selectCurrentWorkforceProviderIdLoading = createLoadingSelector(['WORKFORCE_FIND_CURRENT_PROVIDER_ID']);
const selectLoadingWorkforceConfiguration = createLoadingSelector(['WORKFORCE_FIND_PROVIDER_BY_ID']);
const selectWorkforceLoadingProviderIds = createLoadingSelector(['WORKFORCE_ALL_PROVIDERS_IDS']);

const mapStateToProps = (state) => {

    const mappingCurrentProviderId = getMappingProviders(state).mappingCurrentProviderId,
        mappingProviders = getMappingProviders(state).mappingProviders,
        mappingProviderIds = getMappingProviders(state).mappingProviderIds,
        isLoadingCurrentProviderId = selectCurrentProviderIdLoading(state),
        isLoadingMappingSystemConfiguration = selectLoadingMappingSystemConfiguration(state),
        isLoadingProviderIds = selectLoadingProviderIds(state);

    const currentWorkforceProviderId = getWorkforceProviders(state).workforceCurrentProviderId,
        workforceProviders = getWorkforceProviders(state).workforceProviders,
        workforceProviderIds = getWorkforceProviders(state).workforceProviderIds,
        isLoadingCurrentWorkforceProviderId = selectCurrentWorkforceProviderIdLoading(state),
        isLoadingWorkforceConfiguration = selectLoadingWorkforceConfiguration(state),
        isLoadingWorkforceProviderIds = selectWorkforceLoadingProviderIds(state);

    return {
        mappingCurrentProviderId, mappingProviders, mappingProviderIds, isLoadingCurrentProviderId, currentWorkforceProviderId,
        workforceProviders, workforceProviderIds, isLoadingCurrentWorkforceProviderId, isLoadingMappingSystemConfiguration,
        isLoadingWorkforceConfiguration, isLoadingProviderIds, isLoadingWorkforceProviderIds,
    };
};

const mapDispatchToProps = {
    showModal,
    getMappingSystemProviderById, getMappingSystemCurrentId, getMappingSystemAllProviders, getMappingSystemAllProviderIDS,
    getWorkforceProviderByID, getWorkforceCurrentProviderID, getWorkforceAllProviders, getWorkforceAllProvidersIDS,
    setMappingSystemProvider, setCurrentWorkforce, clearCurrentWorkforceProviderId, clearWorkforceAllIds, clearWorkforceProviderIds,
    clearMappingProviderId, clearMappingAllIds, clearMappingProviderIds, patchMappingSystem, patchWorkforce,
};







export default connect(mapStateToProps, mapDispatchToProps)(WorkforceConfiguration);
